import { checkZoneCellIsFloat } from "@/utils/rules/validate"
import { isUndefined } from "lodash"
import { getMinimumValue, getMaximumValue } from "@/utils/range"

/**
 * Custom threshold 값의 유효성을 검사
 * @param inputValue - 검증할 입력값
 * @param index - customMetrics 배열에서의 인덱스
 * @param values - 전체 customMetrics 값 배열
 * @param active - customMetricActive 상태
 * @param isNegative - 음수 범위 여부
 * @param step - 증감 단위 (hr: 1, others: 0.1)
 * @param min - 최소값
 * @param max - 최대값
 * @returns 에러 여부
 */
/**
 * 셀에 입력 중인 문자열을 받아도 되는지. HR 은 정수만(소수점 자체를 막는다 — 버그 #7·#8),
 * 그 외 탭은 기존 실수 규칙(checkZoneCellIsFloat).
 */
export const isAllowedZoneCellInput = (type: string, value: string): boolean => {
  if (type === "hr") {
    return /^\d*$/.test(value)
  }

  return checkZoneCellIsFloat(value)
}

/** HR 정수 입력란에서 막을 키 — 소수점·지수·부호 */
export const HR_BLOCKED_KEYS = [".", ",", "e", "E", "+", "-"]

export const checkIsErrCustomThreshold = (
  inputValue: string | number,
  index: number,
  values: Array<number | string>,
  active: boolean | undefined,
  isNegative: boolean,
  step: number,
  min: number,
  max: number,
): boolean => {
  if (!active) {
    return false
  }

  const isEmpty = inputValue === "" || isUndefined(inputValue)
  const isNotNumeric = typeof inputValue === "string" && isNaN(Number(inputValue))
  const neighborMin =
    (!isNegative
      ? getMinimumValue(values[index - 1], isNegative, step)
      : getMinimumValue(values[index + 1], isNegative, step)) || (!isNegative ? step : min)
  const neighborMax =
    (!isNegative
      ? getMaximumValue(values[index + 1], isNegative, step, max)
      : getMaximumValue(values[index - 1], isNegative, step, max)) || max
  // 이웃 칸이 없으면 step 으로 떨어져(예: HR Zone 1 → 1) 탭 하한(40bpm)보다 낮은 값이 통과했다.
  // 모든 칸에 탭 범위를 함께 건다 — 이웃 제약과 탭 범위 중 더 좁은 쪽이 기준 (ERR-024)
  const lowerBound = Math.max(min, neighborMin)
  const upperBound = Math.min(max, neighborMax)
  const isNotMin = Number(inputValue) < lowerBound
  const isNotMax = Number(inputValue) > upperBound

  return isEmpty || isNotNumeric || isNotMin || isNotMax
}
